import axios from 'axios'

export default {
  async list (query = null) {
    return axios.get('api/v1/download' + (query ? '?' + query : ''))
  }
}
